import { createSlice } from '@reduxjs/toolkit'

const tournamentParticipantsSlice = createSlice({
	name: 'participants',
	initialState: {
		participants: []
	},
	reducers: {
		setParticipants(state, action) {
			state.participants = action.payload
		},
		addParticipant(state, action) {
			state.participants.push(action.payload)
		},
		updateParticipant(state, action) {
			state.participants = state.participants.map(p => {
				if (p?.uid === action.payload.uid) {
					return p = action.payload
				} else {
					return p
				}
			})
		}
	}
})

export const { setParticipants, addParticipant, updateParticipant } = tournamentParticipantsSlice.actions
export default tournamentParticipantsSlice.reducer